import React, { FC } from "react";
import { PromoKuperModal } from "@/components/PromoKuperModal/PromoKuperModal";
import { ServiceSelector } from "./ServiceSelector";
import { TariffOptions } from "./TariffOptions";
import cls from "./styles.module.scss";

export const TransportModeSelector: FC = () => (
  <div className={cls.selector}>
    <PromoKuperModal />
    <TariffOptions />
    <ServiceSelector />
  </div>
);
